import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../services/form-field-control.service';
import { FormField } from '../../../shared/form-field/form-field';
import { RoleAuthorizationService } from '../../../../../services/role-authorization.service';
import {
  IRoleAuthorizationService,
} from '../../../../../interfaces/role-authorization.interface';
import { FormCanDeactivate } from '../../../shared/form-field/form-can-deactivate';

@Component({
  standalone: false,
  templateUrl: 'permissions-configuration.template.html',
  providers: [FormFieldControlService],
})
export class PermissionsConfigComponent extends FormCanDeactivate {
  @Input() formFields: FormField<string>[] = [];
  @Input() isAdvanced: boolean;
  @Input() isClearSearch: boolean;
  authDetails: IRoleAuthorizationService;
  roleService: RoleAuthorizationService;
  form: FormGroup;
  payLoad = '';

  constructor(
    private qcs: FormFieldControlService,
    roleService: RoleAuthorizationService,
  ) {
    super();
  }
}
